// extracted by mini-css-extract-plugin
export default {"notebook-delete__title":"NotebookDelete_notebook-delete__title__fGIpw","notebook-delete__btn-box":"NotebookDelete_notebook-delete__btn-box__WDHTq"};